module.exports = __webpack_public_path__ + "img/correct-skyblue.9894ba0b.svg";